import script from "./LocalsSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalsSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LocalsSwitcher.vue?vue&type=style&index=0&id=693a9ddd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693a9ddd"]])

export default __exports__